<div class="multi-select-container">
  <div 
    class="input-wrapper" 
    [class.is-open]="isOpen"
    [class.has-selection]="_selectedItems.length > 0"
    [class.has-warning]="requiredCount && _selectedItems.length > 0 && _selectedItems.length < requiredCount && !isOpen"
    [class.is-disabled]="isDisabled"
    (click)="toggleDropdown()">

    <label for="placeholder-label" class="placeholder-label">{{ placeholder }}</label>

    <div class="selected-items-area">
      <span *ngFor="let item of _selectedItems" class="selected-item-chip">
        <span class="chip-label">{{ item.label }}</span>
        <span class="remove-chip" (click)="removeSelectedItem(item, $event)"><i class="bi bi-x"></i></span>
      </span>
    </div>
    <span class="mdn-Icon--md arrow-icon"
          [ngClass]="{ 'mdn-Icon-cima': isOpen, 'mdn-Icon-baixo': !isOpen }"
          [attr.aria-label]="(isOpen ? 'components.multiSelect.ariaLabelClose' : 'components.multiSelect.ariaLabelOpen') | i18n">
    </span>  
  </div>

  <div class="dropdown-panel" *ngIf="isOpen">
    <div class="search-box">
      <span class="mdn-Icon-lupa mdn-Icon--md search-icon" aria-hidden="true"></span>
      <input 
        type="text" 
        [placeholder]="placeholderFilter" 
        [(ngModel)]="searchTerm"
        (input)="filterItems()"
        (click)="$event.stopPropagation()" />
    </div>

    <div class="list-header" *ngIf="listTitle">{{ listTitle }}</div>

    <ul class="options-list">
      <li 
        *ngFor="let item of filteredItems" 
        class="option-item" 
        [class.disabled]="!isSelected(item) && isSelectionLimitReached() && requiredCount !== 1">
        <input 
          type="checkbox" 
          [id]="'item-' + item.id"
          [checked]="isSelected(item)"
          [disabled]="!isSelected(item) && isSelectionLimitReached() && requiredCount !== 1"
          (change)="selectItem(item)"
          (click)="$event.stopPropagation()">
        <label [for]="'item-' + item.id" (click)="$event.stopPropagation()">
          <span *ngIf="isSelected(item)" 
                class="mdn-Icon-check mdn-Icon--sm checkbox-icon" 
                [attr.aria-label]="'components.multiSelect.ariaLabelCheck' | i18n">
          </span>
          {{ item.label }}
        </label>
      </li>
    </ul>
  </div>
  
  <div class="messages-area" *ngIf="!isOpen">
      <div *ngIf="requiredCount && _selectedItems.length > 0 && _selectedItems.length < requiredCount && warningMessage" class="message warning-message">
        <span class="mdn-Icon-circulo-exclamacao mdn-Icon--sm" [attr.aria-label]="'components.multiSelect.ariaLabelWarning' | i18n"></span>
         {{ warningMessage }}
      </div>
  </div>

</div>